import React from "react";
import sayaji from "../assets/Sayaji.png";
import profile from "../assets/Snapch.jpg";
import gdgimg from "../assets/gdgimg.png";
import communityimg from "../assets/community.png";

export function Experience() {
  const data = [
    {
      imgelink: profile,
      work: "Intern",
      text: "SafeSend offers several foundational technology solutions for the tax and accounting profession. SafeSend One is a multi-year winner of the CPA Practice Advisor Technology Innovation Award and has redefined the way accounting firms address tax return processes from getting tax ready and flowing data in and out of tax preparation software, to finishing with tax return delivery and e-signing, in order to file quicker. We solve real-world problems for the tax and accounting profession – from tax ready to finish & file – through award-winning automation SaaS solutions.",
      heading: "upcoming ASD @Safesend Banglore",
    },
    {
      imgelink: communityimg,
      work: "GDSC Lead",
      text: "GDSC IET DAVV is part of a dynamic community where students from diverse backgrounds unite to explore the latest advancements in technology. It's a space for learning about Google's tools and platforms, while also collaborating on innovative projects. The club nurtures growth for developers at all levels, from beginners to advanced, providing opportunities not only for coding but also for networking, collective learning, and personal development. It's a place where the focus is on connecting, learning together, and growing as a community..",
      heading: "Google Developer Lead @IETDAVV ",
    },
    {
      imgelink: gdgimg,
      work: "Community",
      text: "GDG Indore, which stands for Google Developers Group Indore, is a technical-community based in Indore, India. We organize frequent meetup events which include talks on a wide range of technical topics where you can learn new skills through hands-on workshops, online challenges, interaction with the community, and hackathons.The community prides itself on being an inclusive environment where everyone and anyone interested in tech - from beginner developers to experienced professionals.",
      heading: "GDG Indore Core team member",
    },
    {
      imgelink: sayaji,
      work: "Founder",
      text: "AskGuru is a real-time platform designed to connect individuals with experienced mentors for counseling and problem-solving. It aims to offer users immediate access to guidance across various areas of expertise, helping them find solutions, gain insights, and receive mentorship. Whether it's career advice, personal development, or specific technical challenges, AskGuru ensures that users can interact with qualified mentors for timely support. The platform bridges the gap between people seeking help and those offering it, fostering an environment of continuous learning and growth.",
      heading: "founder @askGuru",
    },
  ];

  const [active, setActive] = React.useState(data[0]);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => {
        const currentIndex = data.findIndex((item) => item.work === prev.work);
        const nextIndex = (currentIndex + 1) % data.length;
        return data[nextIndex];
      });
    }, 5000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, [data]);

  return (
    <div
      id="experience"
      className="font-sans pt-10 sm:pt-20 bg-[#1E1E1E] pb-10 min-h-screen"
    >
      {/* Header Section */}
      <div className="px-4 sm:px-6 lg:px-8">
        <h1 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl pt-8 sm:pt-16 text-center leading-tight">
          i have experience of <span className="text-[#FFCD29]">working </span>
          as a
        </h1>
      </div>

      {/* Main Content Section */}
      <div className="px-4 sm:px-6 lg:px-8 pt-10 sm:pt-20 pb-10 sm:pb-20">
        {/* Desktop Layout (md and above) */}
        <div className="hidden md:flex justify-center items-center gap-8 lg:gap-12">
          <div className="flex flex-col justify-start gap-6 lg:gap-8 min-w-[200px] h-[400px] lg:h-[500px] overflow-y-auto scrollbar-hide">
            {data.map((item, index) => (
              <div key={index}>
                <h2
                  onClick={() => setActive(item)}
                  className={`text-[#FFCD29] text-center text-lg lg:text-xl xl:text-2xl cursor-pointer transition-all duration-300 hover:scale-105 px-4 py-2 rounded-lg ${
                    active.work === item.work
                      ? "bg-white text-black shadow-lg"
                      : "hover:bg-gray-800"
                  }`}
                >
                  {item.work}
                </h2>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-center">
            <img
              className="h-[400px] w-[280px] lg:h-[500px] lg:w-[350px] rounded-lg object-cover object-center shadow-xl transition-all duration-300"
              src={active.imgelink}
              alt={active.work}
            />
          </div>

          <div className="flex-1 max-w-lg xl:max-w-xl flex flex-col justify-start items-start text-left h-[400px] lg:h-[500px]">
            <h1 className="text-3xl lg:text-4xl xl:text-5xl text-white mb-8 lg:mb-16 leading-tight pt-0">
              {active.heading}
            </h1>
            <p className="text-white text-sm lg:text-base xl:text-lg leading-relaxed text-left">
              {active.text}
            </p>
          </div>
        </div>

        {/* Mobile and Tablet Layout (below md) */}
        <div className="md:hidden">
          <div className="flex gap-2 sm:gap-4 overflow-x-auto pb-4 mb-8 scrollbar-hide px-4 ">
            {data.map((item, index) => (
              <div key={index} className="flex-shrink-0">
                <h2
                  onClick={() => setActive(item)}
                  className={`text-[#FFCD29] text-center text-sm sm:text-base cursor-pointer transition-all duration-300 px-3 py-2 sm:px-4 sm:py-2 rounded-lg whitespace-nowrap ${
                    active.work === item.work
                      ? "bg-white text-black shadow-lg"
                      : "hover:bg-gray-800 border border-gray-700"
                  }`}
                >
                  {item.work}
                </h2>
              </div>
            ))}
          </div>

          {/* Content Card */}
          <div className="bg-yellow-400 rounded-xl p-4 sm:p-6 shadow-2xl">
            {/* Image */}
            <div className="flex justify-center mb-6">
              <img
                className="h-[250px] w-[200px] sm:h-[300px] sm:w-[240px] rounded-lg object-cover object-center shadow-lg"
                src={active.imgelink}
                alt={active.work}
              />
            </div>

            {/* Content */}
            <div className="text-center sm:text-left">
              <h1 className="text-xl sm:text-2xl lg:text-3xl text-black font-bold mb-4 sm:mb-6 leading-tight">
                {active.heading}
              </h1>
              <p className="text-black-300 text-sm sm:text-base leading-relaxed">
                {active.text}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Custom scrollbar styles */}
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}
